// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2q5h-","head":"ProcedureTableInfo_head__2u8rC"};